var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.338 0.49811C12.9707 0.177438 12.4941 0 12 0C11.5059 0 11.0293 0.177438 10.662 0.49811L0 9.80696V19.8958C0 20.7191 0.337142 21.5086 0.937258 22.0908C1.53737 22.6729 2.35131 23 3.2 23H7V16.1813C7 14.8949 7.52678 13.6612 8.46447 12.7516C9.40215 11.842 10.6739 11.331 12 11.331C13.3261 11.331 14.5979 11.842 15.5355 12.7516C16.4732 13.6612 17 14.8949 17 16.1813V22.9971H20.8C21.6487 22.9971 22.4626 22.67 23.0627 22.0879C23.6629 21.5057 24 20.7161 24 19.8928V9.80405L13.338 0.49811Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterHome);
export default __webpack_public_path__ + "static/media/footer-home.ebb2173428cb22eeecd457709b1c06f7.svg";
export { ForwardRef as ReactComponent };